<div class="flex flex-row flex-wrap gap-10 justify-between w-full">
  @if (ehEmailOuSms) {
    <app-card-info-contato
      class="preencher"
      [ngClass]="ehMobile ? 'mobile' : ''"
      [fontSizeInfo]="'var(--display-metrica)'"
      [quantidade]="quantidadeEnviados"
      [titulo]="'Enviados'"
      [backgroundColor]="'#6213B6'"
    ></app-card-info-contato>
    <app-card-info-contato
      class="preencher"
      [ngClass]="ehMobile ? 'mobile' : ''"
      [fontSizeInfo]="'var(--display-metrica)'"
      [quantidade]="quantidadeEmProcessamento"
      [titulo]="'Em processamento'"
      [backgroundColor]="'#7E1FE4'"
    ></app-card-info-contato>
    <app-card-info-contato
      class="preencher"
      [ngClass]="ehMobile ? 'mobile' : ''"
      [fontSizeInfo]="'var(--display-metrica)'"
      [quantidade]="quantidadeErros"
      [titulo]="'Erros'"
      [backgroundColor]="'#A24FF5'"
    ></app-card-info-contato>
    @if (ehEmail) {
      <app-card-info-contato
        class="preencher"
        [ngClass]="ehMobile ? 'mobile' : ''"
        [fontSizeInfo]="'var(--display-metrica)'"
        [quantidade]="quantidadeBlacklist"
        [titulo]="'BlackList'"
        [backgroundColor]="'#C286FF'"
      ></app-card-info-contato>
      <app-card-info-contato
        class="preencher"
        [ngClass]="ehMobile ? 'mobile' : ''"
        [fontSizeInfo]="'var(--display-metrica)'"
        [quantidade]="quantidadeInvalidos"
        [titulo]="'Inválidos'"
        [backgroundColor]="'#DDBAFF'"
        [colorText]="'var(--primary)'"
      ></app-card-info-contato>
    }
    <app-card-info-contato
      class="preencher"
      [ngClass]="ehMobile ? 'mobile' : ''"
      [fontSizeInfo]="ehMobile ? 'var(--text-primary-font-10-12)' : 'var(--title-primary-font-18-20)'"
      [quantidade]="custoDisparo"
      [titulo]="'Custo Aproximado'"
      [backgroundColor]="'#F2E4FF'"
      [colorText]="'var(--primary)'"
      [isMoeda]="true"
      [moeda]="moedaCusto"
    ></app-card-info-contato>
  } @else {
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="quantidadeEnviados"
    [titulo]="'Enviados'"
    [backgroundColor]="'#6213B6'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="quantidadeRecebidos"
    [titulo]="'Recebidos'"
    [backgroundColor]="'#7E1FE4'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="quantidadeLidos"
    [titulo]="'Lidos'"
    [backgroundColor]="'#A24FF5'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="quantidadeErros"
    [titulo]="'Erros'"
    [backgroundColor]="'#A24FF5'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="quantidadePorcentagemConversao"
    [isPorcentagem]="true"
    [titulo]="'% de Conversão'"
    [backgroundColor]="'#C286FF'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="interacao"
    [titulo]="'Interação'"
    [backgroundColor]="'#F2E4FF'"
    [colorText]="'var(--primary)'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="possuemSessao"
    [titulo]="'Possuem sessão'"
    [backgroundColor]="'#F2E4FF'"
    [colorText]="'var(--primary)'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="ehMobile ? 'var(--text-primary-font-10-12)' : 'var(--title-primary-font-18-20)'"
    [quantidade]="custoDisparo"
    [titulo]="'Custo Aproximado'"
    [backgroundColor]="'#F2E4FF'"
    [colorText]="'var(--primary)'"
    [isMoeda]="true"
    [moeda]="moedaCusto"
  ></app-card-info-contato>
  @if (isFluxoPesquisa){
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="quantidadePesquisasRespondidas"
    [titulo]="'Pesquisas Respondidas'"
    [backgroundColor]="'#DDBAFF'"
  ></app-card-info-contato>
  <app-card-info-contato
    [ngClass]="ehMobile ? 'mobile' : ''"
    [fontSizeInfo]="'var(--display-metrica)'"
    [quantidade]="quantidadePorcentagemPesquisasRespondidas"
    [isPorcentagem]="true"
    [titulo]="'% Pesquisas Respondidas'"
    [backgroundColor]="'#EDDBFF'"
  ></app-card-info-contato>
  }
  }
</div>
